export default __webpack_public_path__ + "static/media/sukukalkhair.d6395fa7.png";